import { Translate } from '@dreryk/react-common';
import { appendTestableElementAttributes } from '@dreryk/react-components';

import { dashboardTranslationKeys } from '../../../translations';
import { StyledCard } from '../shared/Card.styled';

import { RegisteredAppointmentsLoader } from './RegisteredAppointments.loader';
import { StyledRegisteredAppointments } from './RegisteredAppointments.styled';
import { RegisteredAppointmentsCardCount } from './RegisteredAppointmentsCardCount';
import { RegisteredAppointmentsChart } from './RegisteredAppointmentsChart';

export const RegisteredAppointmentsCard = (): JSX.Element => {
   return (
      <StyledCard {...appendTestableElementAttributes('registered')}>
         <RegisteredAppointmentsLoader>
            {({ appointmentsView }) => (
               <StyledRegisteredAppointments direction='column' gap={12} flex='1'>
                  <RegisteredAppointmentsCardCount appointmentsView={appointmentsView} />
                  <Translate>{dashboardTranslationKeys.cards.registered}</Translate>
                  <RegisteredAppointmentsChart appointmentsView={appointmentsView} />
               </StyledRegisteredAppointments>
            )}
         </RegisteredAppointmentsLoader>
      </StyledCard>
   );
};
